import { createSlice } from '@reduxjs/toolkit'

export const SourceFilesSlice = createSlice(
  {
  name: 'source_files',
  initialState: {
    value: [],
  },
  reducers: {
    updateSourceFiles: (state, action) => {
      state.value = action.payload
    },
  },
})
export const { updateSourceFiles } = SourceFilesSlice.actions

export default SourceFilesSlice.reducer